<template>
  <div id="app">
    <SEOImageOptimizer />
    <HeaderNav />
    <main class="main-content">
      <router-view/>
    </main>
    <!-- WhatsApp Button -->
    <div class="whatsapp-btn" @click="openWhatsApp">
      <svg class="whatsapp-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
      <span class="whatsapp-text">Get in touch with us</span>
    </div>
  </div>
</template>

<script>
import HeaderNav from './components/HeaderNav.vue'
import SEOImageOptimizer from './components/SEOImageOptimizer.vue'

export default {
  name: 'App',
  components: {
    HeaderNav,
    SEOImageOptimizer
  },
  watch: {
    '$route' (to) {
      // Watch for route changes and update meta tags
      this.updateMetaTags(to)
    }
  },
  methods: {
    openWhatsApp () {
      const phoneNumber = '+250788539359'
      const message = encodeURIComponent('Hello! I\'m interested in renting a car in Rwanda. Can you help me?')
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`
      window.open(whatsappUrl, '_blank')
    },
    updateMetaTags (route) {
      // Update canonical URL
      let canonicalTag = document.querySelector('link[rel="canonical"]')
      if (!canonicalTag) {
        canonicalTag = document.createElement('link')
        canonicalTag.setAttribute('rel', 'canonical')
        document.head.appendChild(canonicalTag)
      }
      const baseUrl = 'https://rwandakigaliselfdrive.com'
      canonicalTag.setAttribute('href', `${baseUrl}${route.path}`)

      // Update Open Graph URL
      let ogUrlTag = document.querySelector('meta[property="og:url"]')
      if (!ogUrlTag) {
        ogUrlTag = document.createElement('meta')
        ogUrlTag.setAttribute('property', 'og:url')
        document.head.appendChild(ogUrlTag)
      }
      ogUrlTag.setAttribute('content', `${baseUrl}${route.path}`)
    }
  },
  mounted () {
    // Initial meta tag setup
    this.updateMetaTags(this.$route)
  }
}
</script>

<style>
/* Essential CSS Reset and Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.6;
  color: #333;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

button {
  cursor: pointer;
  border: none;
  outline: none;
  background: none;
}

a {
  text-decoration: none;
  color: inherit;
}

.main-content {
  padding-top: 130px;
  min-height: calc(100vh - 130px);
}

/* WhatsApp Button Styles */
.whatsapp-btn {
  position: fixed;
  bottom: 30px;
  right: 30px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #25D366;
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 14px 22px;
  cursor: pointer;
  z-index: 999999;
  box-shadow: 0 4px 16px rgba(37, 211, 102, 0.45);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  animation: pulse 2s infinite;
  text-decoration: none;
}

.whatsapp-btn:hover {
  transform: scale(1.06);
  box-shadow: 0 6px 24px rgba(37, 211, 102, 0.6);
  animation: none;
}

.whatsapp-icon {
  width: 28px;
  height: 28px;
  fill: #fff;
  flex-shrink: 0;
}

.whatsapp-text {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  color: #fff;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .whatsapp-btn {
    bottom: 20px;
    right: 15px;
    padding: 12px 18px;
    gap: 8px;
  }

  .whatsapp-icon {
    width: 24px;
    height: 24px;
  }

  .whatsapp-text {
    font-size: 13px;
  }
}

/* Subtle float animation */
@keyframes pulse {
  0%   { transform: translateY(0px); }
  50%  { transform: translateY(-5px); }
  100% { transform: translateY(0px); }
}
</style>
